export enum TimelineType {
  SPECIAL = 'special',
  WEEK = 'week',
  MODULE = 'module',
  MAIN = 'main'
}
